// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pRJR","newExpiryDate":"styles_newExpiryDate__2WJUG","footer":"styles_footer__2G5PW"};